<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
        <form
          class="searchForm"
          action="/users"
        >
          <md-field>
            <label>Search by email</label>
            <md-input
              name="email"
              :disabled="isLoading"
            />
          </md-field>

          <md-field>
            <label>Search by ID</label>
            <md-input
              name="id"
              :disabled="isLoading"
            />
          </md-field>

          <md-button
            class="md-primary searchButton"
            type="submit"
          >
            Search
          </md-button>
        </form>

        <header class="subscriptions-header">
          <h2>User details</h2>
          <md-button @click.native="rawDataDialog.active = true">
            Show raw data
          </md-button>
        </header>

        <md-progress-bar
          v-if="isLoading"
          md-mode="query"
        />
        <md-content
          v-else
          class="content"
        >
          <div class="row">
            <static-info-field
              label="Email"
              :value="user.Account.email.email"
            />

            <md-button
              class="inRowButton"
              @click="changeEmailDialog.active = true"
            >
              Change
            </md-button>

            <static-info-field
              label="Email verified?"
              :value="user.Account.email.verified"
            />

            <static-info-field
              label="Subscribed to newsletter"
              :value="user.Account.receive_newsletters"
            />
          </div>

          <static-info-field
            label="ID"
            :value="user.Account.id"
          />

          <div class="row">
            <static-info-field
              label="Password set?"
              :value="user.Account.is_password_set"
            />

            <md-button
              class="inRowButton"
              @click="passwordResetDialog.active = true"
            >
              Send password reset
            </md-button>
          </div>

          <div class="row">
            <static-info-field
              label="Type"
              :value="user.Account.type"
            />

            <static-info-field
              label="State"
              :value="user.Account.state"
            />

            <static-info-field
              label="Diia verified"
              :value="user.Account.diia_verified"
            />
          </div>

          <static-info-field
            label="Created at"
            :value="(new Date(user.Account.created_at)).toUTCString()"
          />

          <div class="row">
            <static-info-field
              label="Organization"
              :value="user.Account.organization"
            />

            <static-info-field
              label="Registration source"
              :value="user.Account.registration_source"
            />

            <static-info-field
              label="Registration country"
              :value="user.Account.registration_country_iso"
            />
          </div>

          <div class="row">
            <static-info-field
              label="Marked for termination"
              :value="user.Account.marked_for_termination"
            />

            <static-info-field
              v-if="user.Account.marked_for_termination"
              label="Termination date"
              :value="(new Date(user.Account.termination_date)).toUTCString()"
            />

            <md-button
              v-if="user.Account.marked_for_termination"
              class="inRowButton md-primary"
              @click="restoreAccountDialog.active = true"
            >
              Restore account
            </md-button>

            <md-button
              v-if="!user.Account.marked_for_termination"
              class="inRowButton dangerButton"
              @click="deleteAccountDialog.active = true"
            >
              Delete account
            </md-button>
          </div>
        </md-content>

        <md-content
          v-if="!isLoading"
          class="content"
        >
          <header class="subscriptions-header">
            <h4>Subscriptions</h4>

            <md-field class="statusFilter">
              <label>Filter by status</label>
              <md-select
                v-model="subscriptionFilter.current"
              >
                <md-option
                  v-for="option in subscriptionFilter.options"
                  :key="option.value"
                  :value="option.value"
                >
                  {{ option.label }}
                </md-option>
              </md-select>
            </md-field>

            <md-button @click="redeemPromoDialog.active = true">
              Apply a promocode
            </md-button>
          </header>
          <span v-if="user.subscriptions.subscriptions.length === 0">None</span>
          <user-subscription-view
            v-for="sub in $filteredSubscriptions"
            v-else
            :key="sub.subscription_id"
            :subscription="sub"
            @subscriptionCancel="onCancelButtonClick"
          />
        </md-content>

        <md-content
          v-if="!appleNotifications.isLoading"
          class="content"
        >
          <h4>Apple Notifications</h4>

          <span>{{ appleNotifications.notifications.length }} Apple notification(s) found.</span>

          <div
            v-for="notif in appleNotifications.notifications"
            :key="notif.uuid"
            class="notification-card"
          >
            <div class="row">
              <static-info-field
                label="Notification type"
                :value="notif.notification_type"
              />
              <static-info-field
                label="Sub type"
                :value="notif.sub_type"
              />
              <static-info-field
                label="Original transaction ID"
                :value="notif.original_transaction_id"
              />
            </div>
            <div class="row">
              <static-info-field
                label="UUID"
                :value="notif.uuid"
              />
              <static-info-field
                label="Created at"
                :value="(new Date(notif.created_at)).toUTCString()"
              />
            </div>

            <prism-editor
              v-if="notif.payload"
              v-model="notif.payload"
              label="Notification payload"
              language="json"
              :readonly="true"
            />
          </div>
        </md-content>

        <md-content
          v-if="!isLoading"
          class="content"
        >
          <h4>Referral</h4>

          <div class="row">
            <static-info-field
              label="Number of referred users"
              :value="user.Account.referral.referrals_count"
            />

            <static-info-field
              label="Limit of referred users"
              :value="user.Account.referral.referrals_limit"
            />

            <static-info-field
              label="Referral link"
              :value="user.Account.referral.referral_url"
              :href="user.Account.referral.referral_url"
            />
          </div>

          <div class="row">
            <static-info-field
              label="Has been invited by"
              :value="user.Account.referral.referrer_id || '-'"
              :href="user.Account.referral.referrer_id ? '/user/'+user.Account.referral.referrer_id : ''"
            />
          </div>
        </md-content>

        <device-section
          v-if="!isLoading"
          :devices="user.Account.devices"
          @deviceUnlink="onDeviceUnlinkClick"
        />

        <md-dialog :md-active.sync="changeEmailDialog.active">
          <md-dialog-title>
            Change user's email?
          </md-dialog-title>
          <md-dialog-content>
            <md-field :class="{ 'md-invalid': changeEmailDialog.isInputInvalid }">
              <label>New email</label>
              <md-input
                ref="changeEmailInput"
                v-model="changeEmailDialog.newEmailValue"
                type="email"
              />
              <span class="md-error">Invalid email</span>
            </md-field>
          </md-dialog-content>
          <md-dialog-actions>
            <md-button
              @click="changeEmailDialog.active = false"
            >
              Close
            </md-button>
            <md-button
              class="md-primary"
              @click="onChangeEmailSubmit"
            >
              Save
            </md-button>
          </md-dialog-actions>
        </md-dialog>

        <md-dialog :md-active.sync="redeemPromoDialog.active">
          <md-dialog-title>
            Apply promocode for user
          </md-dialog-title>
          <md-dialog-content>
            <md-field :class="{ 'md-invalid': redeemPromoDialog.error }">
              <label>Promocode</label>
              <md-input v-model="redeemPromoDialog.promoValue" />
              <span class="md-error">{{ redeemPromoDialog.error }}</span>
            </md-field>
          </md-dialog-content>
          <md-dialog-actions>
            <md-button
              @click="redeemPromoDialog.active = false"
            >
              Close
            </md-button>
            <md-button
              class="md-primary"
              @click="onPromocodeRedeem"
            >
              Apply
            </md-button>
          </md-dialog-actions>
        </md-dialog>

        <md-dialog
          :md-active.sync="rawDataDialog.active"
        >
          <md-dialog-title>Raw user details</md-dialog-title>

          <md-dialog-content>
            <pre>{{ JSON.stringify(user, null, 4) }}</pre>
          </md-dialog-content>

          <md-dialog-actions>
            <md-button
              class="md-primary"
              @click="rawDataDialog.active = false"
            >
              Close
            </md-button>
          </md-dialog-actions>
        </md-dialog>

        <md-dialog-confirm
          :md-active.sync="deleteAccountDialog.active"
          md-title="Delete user's account?"
          md-confirm-text="Delete"
          md-cancel-text="Cancel"
          @md-cancel="deleteAccountDialog.active = false"
          @md-confirm="onAccountDelete"
        />

        <md-dialog-confirm
          :md-active.sync="restoreAccountDialog.active"
          md-title="Restore user's account?"
          md-confirm-text="Restore"
          md-cancel-text="Cancel"
          @md-cancel="restoreAccountDialog.active = false"
          @md-confirm="onAccountRestore"
        />

        <md-dialog-confirm
          :md-active.sync="passwordResetDialog.active"
          md-title="Send the user a password reset email?"
          md-confirm-text="Send"
          md-cancel-text="Cancel"
          @md-cancel="passwordResetDialog.active = false"
          @md-confirm="onPasswordReset"
        />

        <md-dialog-confirm
          :md-active.sync="subscriptionCancelDialog.active"
          md-title="Cancel user's subscription?"
          md-confirm-text="Yes"
          md-cancel-text="No"
          @md-cancel="subscriptionCancelDialog.active = false"
          @md-confirm="onSubscriptionCancel"
        />

        <md-dialog-confirm
          :md-active.sync="deviceUnlinkDialog.active"
          md-title="Unlink user's device?"
          md-confirm-text="Unlink"
          md-cancel-text="Cancel"
          @md-cancel="deviceUnlinkDialog.active = false"
          @md-confirm="onUnlinkDevice"
        />
      </div>
    </div>
  </div>
</template>
<script>
    import StaticInfoField from "../components/UserDetails/StaticInfoField";
    import UserSubscriptionView from "../components/UserDetails/UserSubscriptionView";
    import DeviceSection from "../components/UserDetails/DevicesSection";
    import PrismEditor from "vue-prism-editor";

    export default {
        name: "UsersPage",
        components: {
          StaticInfoField,
          UserSubscriptionView,
          DeviceSection,
          PrismEditor
        },
        data() {
            return {
              isLoading: true,
              user: {},
              appleNotifications: {
                isLoading: true,
                error: null,
                notifications: []
              },

              subscriptionFilter: {
                current: "",
                options: [{ label: "All", value: "" }],
              },

              changeEmailDialog: {
                active: false,
                newEmailValue: "",
                isInputInvalid: false
              },
              redeemPromoDialog: {
                active: false,
                promoValue: "",
                error: ""
              },
              deleteAccountDialog: {
                active: false
              },
              restoreAccountDialog: {
                active: false
              },
              passwordResetDialog: {
                active: false
              },
              subscriptionCancelDialog: {
                active: false,
                subscriptionId: ""
              },
              deviceUnlinkDialog: {
                active: false,
                deviceId: ""
              },
              rawDataDialog: {
                active: false
              }
            };
        },
        computed: {
          $filteredSubscriptions() {
            if (!this.subscriptionFilter.current) {
              return this.user.subscriptions.subscriptions;
            }

            return this.user.subscriptions.subscriptions.filter(sub => sub.account_subscription.status === this.subscriptionFilter.current);
          }
        },
        mounted() {
          this.fetchAccount();
          this.fetchAppleNotifications();
        },
        methods: {
          fetchAccount() {
            this.isLoading = true;

            this.$http.get(`/v1/admin/account/details?filters.account_id=${this.$route.params.id}`)
              .then(res => {
                this.user = res.data;
                this.user.subscriptions.subscriptions.sort((a, b) => new Date(b.account_subscription.created_at) - new Date(a.account_subscription.created_at));

                const subscriptionStatuses = new Set();
                this.user.subscriptions.subscriptions.forEach(sub => {
                  subscriptionStatuses.add(sub.account_subscription.status);
                });
                subscriptionStatuses.forEach(status => {
                  this.subscriptionFilter.options.push({ label: status, value: status });
                });
              })
              .then(() => { this.isLoading = false; });
          },
          fetchAppleNotifications() {
            this.appleNotifications.isLoading = true;

            this.$http.get(`/v1/admin/store/apple/notifications/v2/${this.$route.params.id}`)
              .then((response) => {
                this.appleNotifications.isLoading = false;
                this.appleNotifications.notifications = response.data.notifications;
              }, (error) => {
                this.appleNotifications.isLoading = false;
                this.appleNotifications.error = error.response.data.message || "Apple Notifications loading failed";
              });
          },
          onChangeEmailSubmit () {
            this.changeEmailDialog.isInputInvalid = !this.$refs.changeEmailInput.$el.validity.valid;

            if (this.changeEmailDialog.isInputInvalid) {
              return;
            }

            this.$http.post("/v1/admin/account/change-email", {
              account_id: this.$route.params.id,
              new_email: this.changeEmailDialog.newEmailValue
            }).then(() => {
              this.$notify({
                group: "foo",
                title: "User email updated",
              });
              window.location.reload();
            }).catch(err => {
              this.$notify({
                group: "foo",
                title: `Error with changing email: ${err}`,
              });
            });
          },
          onAccountDelete () {
            this.$http.post("/v1/admin/account/delete", {
              account_id: this.$route.params.id,
            }).then(() => {
              this.$notify({
                group: "foo",
                title: "User deleted",
              });
              window.location.reload();
            }).catch(err => {
              this.$notify({
                group: "foo",
                title: `Error with deleting user: ${err}`,
              });
            });
          },
          onAccountRestore () {
            this.$http.post("/v1/admin/account/restore", {
              account_id: this.$route.params.id,
            }).then(() => {
              this.$notify({
                group: "foo",
                title: "User restored",
              });
              window.location.reload();
            }).catch(err => {
              this.$notify({
                group: "foo",
                title: `Error with restoring user: ${err}`,
              });
            });
          },
          onPasswordReset () {
            this.$http.post("/v1/admin/account/reset-password", {
              email: this.user.Account.email.email
            }).then(() => {
              this.$notify({
                group: "foo",
                title: "Password reset email sent",
              });
            }).catch(err => {
              this.$notify({
                group: "foo",
                title: `Error with sending password reset: ${err}`,
              });
            });
          },
          onCancelButtonClick (subscriptionId) {
            this.subscriptionCancelDialog.active = true;
            this.subscriptionCancelDialog.subscriptionId = subscriptionId;
          },
          onSubscriptionCancel () {
            this.$http.post("/v1/admin/subscription/cancel", {
              subscription_id: this.subscriptionCancelDialog.subscriptionId
            }).then(() => {
              this.$notify({
                group: "foo",
                title: "Subscription has been canceled",
              });
              window.location.reload();
            }).catch(err => {
              this.$notify({
                group: "foo",
                title: `Error with canceling subscription reset: ${err}`,
              });
            });
          },
          onPromocodeRedeem() {
            if (this.redeemPromoDialog.promoValue.length < 2) {
              this.redeemPromoDialog.error = "Must have a promocode";
            }

            this.$http.post("/v1/admin/account/promocode/apply", {
              account_id: this.user.Account.id,
              promocode: this.redeemPromoDialog.promoValue
            })
              .then(() => {
                this.$notify({
                  group: "foo",
                  title: "Promocode applied",
                });
                window.location.reload();
              })
              .catch(err => {
                this.redeemPromoDialog.error = err.message;
              });
          },
          onDeviceUnlinkClick (deviceId) {
            this.deviceUnlinkDialog.active = true;
            this.deviceUnlinkDialog.deviceId = deviceId;
          },
          onUnlinkDevice () {
            this.$http.post("/v1/admin/account/device/unlink", {
              device_id: this.deviceUnlinkDialog.deviceId,
              account_id: this.$route.params.id
            }).then(() => {
              this.$notify({
                group: "foo",
                title: "Device has been unlinked",
              });
              window.location.reload();
            }).catch(err => {
              this.$notify({
                group: "foo",
                title: `Error with unlinking device: ${err}`,
              });
            });
          }
        }
    };
</script>

<style lang="scss" scoped>
  .content {
    padding: 12px;
    border-radius: 8px;

    & + & {
      margin-top: 24px;
    }
  }

  .row {
    display: flex;
    column-gap: 16px;

    @media only screen and (max-width: 800px) {
      flex-wrap: wrap;
    }
  }

  .inRowButton {
    align-self: center;
    height: 32px;

    & > div {
      padding: 12px;
    }
  }

  .dangerButton {
    background-color: #ad1457 !important;
  }

  .subscriptions-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .notification-card {
    padding: 12px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    margin-top: 12px;
  }

  .statusFilter {
    max-width: 300px;
  }
</style>
